import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ChartTypeEnum, QuestionTypeEnum } from '@core/interfaces';
import { endOfDay, mapIds, startOfDay } from '@core/utils/filters-utils';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { TranslateService } from '@ngx-translate/core';
import { isEmpty, isInteger } from 'lodash';
import { Subject } from 'rxjs';
import { debounceTime, filter, map, switchMap, takeUntil } from 'rxjs/operators';
import { sentry } from 'sentry';
import { FilterService } from '../filter/filter.service';
import { FormsReportService } from '../services/forms-report.service';
var DashboardFormsDetailComponent = /** @class */ (function () {
    function DashboardFormsDetailComponent(fuseProgressBarService, formsReportService, translateService, filterService, route, titleService, router) {
        this.fuseProgressBarService = fuseProgressBarService;
        this.formsReportService = formsReportService;
        this.translateService = translateService;
        this.filterService = filterService;
        this.route = route;
        this.titleService = titleService;
        this.router = router;
        this.isLoading = true;
        this.removeSubscriptions = new Subject();
        this.formsColors = ['#1d4ed8', '#38bdf8', '#0f766e', '#34d399', '#a16207', '#fbbf24', '#44403c', '#a3a3a3', '#7e22ce', '#a78bfa'];
        this.questionIcons = [
            { type: 'multipleChoice', icon: 'radio_button_checked' },
            { type: 'list', icon: 'list_alt' },
            { type: 'numeric', icon: 'format_list_numbered' },
            { type: 'paragraph', icon: 'text_snippet' },
            { type: 'shortAnswer', icon: 'text_fields' },
            { type: 'checkboxes', icon: 'library_add_check' },
            { type: 'dropdown', icon: 'list_alt' },
            { type: 'date', icon: 'date_range' },
            { type: 'hour', icon: 'timer' },
            { type: 'multiplePicture', icon: 'collections' },
            { type: 'picture', icon: 'photo' },
            { type: 'currency', icon: 'attach_money' },
            { type: 'email', icon: 'mail' },
            { type: 'phone', icon: 'call' },
            { type: 'document', icon: 'assignment_ind' }
        ];
    }
    DashboardFormsDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (isEmpty(this.route.snapshot.queryParams)) {
            this.router.navigate(['/relatorios/formularios']);
            return;
        }
        var formId = this.route.snapshot.queryParams.formId_eq;
        this.filterService.valueChanges.pipe(map(function () { return ({ source: 'filter' }); }))
            .pipe(takeUntil(this.removeSubscriptions), filter(function () { return _this.filterService.filterForm.valid; }), debounceTime(200), switchMap(function () { return _this.updateData(); })).subscribe();
        this.formsReportService.getFormById(formId)
            .then(function (selectedForm) {
            _this.filterService.selectedForm = selectedForm;
            var pageTitle = _this.translateService.instant('DASHBOARD_FORMS.DETAIL.TITLE', { formName: selectedForm.name });
            _this.titleService.setTitle(pageTitle);
        }).catch(function () {
            _this.router.navigate(['/relatorios/formularios']);
        });
        this.filterService.setFilterFromQueryParams();
        this.filterService.reload();
    };
    DashboardFormsDetailComponent.prototype.ngOnDestroy = function () {
        this.removeSubscriptions.next();
        this.removeSubscriptions.complete();
    };
    DashboardFormsDetailComponent.prototype.toQuery = function (value) {
        return {
            formId_eq: this.route.snapshot.queryParams.formId_eq,
            locationId_in: mapIds(value.locations),
            segmentId_in: mapIds(value.segments),
            companyId_in: mapIds(value.companies),
            createdAt_lte: endOfDay(value.finalDate),
            createdAt_gte: startOfDay(value.initialDate),
            locationGroupId_in: mapIds(value.locationGroups),
            maintenanceTypeId_in: mapIds(value.maintenanceTypes)
        };
    };
    DashboardFormsDetailComponent.prototype.updateData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var where, _a, err_1;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        this.fuseProgressBarService.show();
                        where = this.toQuery(this.filterService.value);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        _a = this;
                        return [4 /*yield*/, this.formsReportService.accountFormsAnswersDetail(where)];
                    case 2:
                        _a.questions = _b.sent();
                        this.questions.map(function (question) {
                            question.answers.map(function (answer) {
                                answer['name'] = answer['value'];
                                answer['value'] = answer['count'];
                                return answer;
                            });
                            if (_this.isGraph(question.type)) {
                                question.chartType = ChartTypeEnum['bar'];
                            }
                            return question;
                        });
                        this.filterService.questionsCount = this.questions.length;
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _b.sent();
                        sentry.captureException(err_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.isLoading = false;
                        this.fuseProgressBarService.hide();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    DashboardFormsDetailComponent.prototype.isGraph = function (type) {
        return ['dropdown', 'checkboxes', 'multipleChoice'].includes(QuestionTypeEnum[type]);
    };
    DashboardFormsDetailComponent.prototype.changeChart = function (question, chartType) {
        question.chartType = chartType;
    };
    DashboardFormsDetailComponent.prototype.formatValue = function (value) {
        return isInteger(value) ? value : '';
    };
    return DashboardFormsDetailComponent;
}());
export { DashboardFormsDetailComponent };
